// @flow
import { all, fork, put, takeLatest, call } from 'redux-saga/effects';

import { getLogEntries as getLogEntriesApi } from '../../helpers/';
import { activityLogApiResponseError, activityLogApiResponseSuccess } from './actions';
import { ActivityLogActionTypes } from './constants';
import { paginationHeadersResponse } from '../../helpers/mappers/pagination';
import { addToast } from '../actions';

const mapLogEntryResponse = (logEntry) => ({
    id: logEntry.id,
    userId: logEntry.user_id,
    createdAt: logEntry.created_at,
    logEntryType: logEntry.log_entry_type,
    message: logEntry.message,
    integrationId: logEntry.integration_id,
    externalOrderId: logEntry.external_order_id,
    lineNumber: logEntry.line_number,
});

function* getLogEntries({ payload: { query } }) {
    try {
        const response = yield call(getLogEntriesApi, query);
        const logEntries = (response.data || []).map(mapLogEntryResponse);
        const pagination = paginationHeadersResponse(response.headers);

        yield put(
            activityLogApiResponseSuccess(ActivityLogActionTypes.GET_LOG_ENTRIES, { logEntries, pagination })
        );
    } catch (error) {
        const message = error?.errors?.[0]?.message ?? 'Unable to fetch activity log';
        yield put(addToast({ desc: message, type: 'error' }));
        yield put(activityLogApiResponseError(ActivityLogActionTypes.GET_LOG_ENTRIES, error));
    }
}

export function* watchGetLogEntries(): any {
    yield takeLatest(ActivityLogActionTypes.GET_LOG_ENTRIES, getLogEntries);
}

function* activityLogSaga(): any {
    yield all([fork(watchGetLogEntries)]);
}

export default activityLogSaga;
